import { CustomerInvoiceRequest } from '@/types/customer/CustomerRequestType'
import { Translator } from '../../types/ApiResponseTypes'

import { isInvoiceCustomerRequestBody } from '@/types/invoice/InvoiceResponse'

class CustomerRequestTranslator implements Translator<CustomerInvoiceRequest> {
  convert(request: any): CustomerInvoiceRequest {
    if (isInvoiceCustomerRequestBody(request)) {
      return this.convertToCustomerRequestAddress(request)
    }
    return {} as CustomerInvoiceRequest
  }

  convertToCustomerRequestAddress(request: any): CustomerInvoiceRequest {
    return {
      emailAddressInvoice: request.invoiceMethod.emailAddress,
      invoiceByPost: request.invoiceMethod.post == true ? 1 : 0,
      street: request.billingAddress.street,
      streetNumber: request.billingAddress.number,
      streetNumberAlpha: '',
      bus: request.billingAddress.bus,
      zipCode: request.billingAddress.postalCode,
      city: request.billingAddress.city,
      countryId: request.billingAddress.countryId,
    }
  }
}
export default new CustomerRequestTranslator()
